<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título -->
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">Empresas con línea de crédito</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes visualizar la situación financiera por empresa en factoraje tradicional.
          </div>
        </v-col>
      </v-row>

      <!-- Filtro + botón -->
      <v-row class="d-flex ma-0 mb-4" justify="space-between" align="center">
        <v-col cols="12" sm="6" md="4" class="pl-0 py-0">
          <v-text-field
            v-model="textoBusqueda"
            label="Buscar empresa"
            clearable
            outlined
            hide-details
            class="mr-2"
            style="font-family: 'montserrat-medium'; border-radius: 20px;"
          />
        </v-col>

        <v-col cols="12" sm="6" md="4" class="d-flex justify-end">
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="crearCliente()">
            Crear Cliente
          </v-btn>
        </v-col>
      </v-row>

      <!-- Tabla Desktop -->
      <v-data-table class="d-none d-sm-block" hide-default-header :items="empresasFiltradas">
        <template v-slot:header>
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Empresa</th>
              <th class="header__title center">Línea usada</th>
              <th class="header__title center">Línea total</th>
              <th class="header__title center">% usada</th>
              <th class="header__title center">Recargos</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="empresa in items" :key="empresa.id">
              <td class="table__item">{{ empresa.empresa }}</td>
              <td class="table__item center">{{ "$ " + formatMoney(empresa.linea_usada) + " USD" }}</td>
              <td class="table__item center">{{ "$ " + formatMoney(empresa.linea_total) + " USD" }}</td>
              <td class="table__item center">{{ ((empresa.linea_usada / empresa.linea_total) * 100).toFixed(2) + " %" }}</td>
              <td class="table__item center" :class="empresa.deuda_activa > 0 ? 'red--text' : ''">
                {{ "$ " + formatMoney(empresa.deuda_activa) + " USD" }}
              </td>
              <td class="table__item">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDetail(empresa)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon left>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver facturas</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- Tabla Mobile -->
      <v-data-table class="d-sm-none d-block" hide-default-header :items="empresasFiltradas">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="empresa in items" :key="empresa.id" style="display: flex; flex-direction: column;">
              <td class="table__item__mobile"><strong>Empresa</strong><div>{{ empresa.empresa }}</div></td>
              <td class="table__item__mobile"><strong>Línea usada</strong><div>{{ "$ " + formatMoney(empresa.linea_usada) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Línea total</strong><div>{{ "$ " + formatMoney(empresa.linea_total) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>% usada</strong><div>{{ ((empresa.linea_usada / empresa.linea_total) * 100).toFixed(2) + " %" }}</div></td>
              <td class="table__item__mobile"><strong>Deuda activa</strong><div>{{ "$ " + formatMoney(empresa.deuda_activa) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Fact. vencidas</strong><div>{{ empresa.facturas_vencidas }}</div></td>
              <td class="table__item__mobile d-flex justify-end">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDetail(empresa)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver facturas</span>
                </v-tooltip>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textoBusqueda: '',
      enterprises: [],
      empresas: [
        {
          id: 1,
          nombre: 'ACME S.A.',
          lineaTotal: 500000,
          lineaUsada: 450000,
          porcentajeUsado: 90,
          deudaActiva: 25000,
          facturasVencidas: 2,
          penalizaciones: 15000
        },
        {
          id: 2,
          nombre: 'Logística Fénix',
          lineaTotal: 300000,
          lineaUsada: 100000,
          porcentajeUsado: 33,
          deudaActiva: 0,
          facturasVencidas: 0,
          penalizaciones: 0
        }
      ]
    }
  },
  computed: {
    empresasFiltradas() {
      if (!this.textoBusqueda) return this.enterprises
      const busqueda = this.textoBusqueda.toLowerCase()
      return this.enterprises.filter(e => e.nombre.toLowerCase().includes(busqueda))
    }
  },
  methods: {
    async getEnterprises() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/admin/enterprises`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.enterprises = response.data.enterprises;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney(value) {
      let multiplied = value * 100
      let rounded = Math.round(multiplied)
      let formattedNumber = rounded / 100
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber)
    },
    openDetail(empresa) {
      this.$router.push({
        name: 'facturasEmpresa',
        params: { empresaId: empresa.enterpriseId }
      })
    },
    crearCliente() {
      this.$router.push({ name: 'crearCliente' })
    }
  },
  beforeMount() {
    this.getEnterprises();
  }
}
</script>
